<div *ngFor="let s of sizes; trackBy: trackByIndex" class="{{s.css + ' ' + (prefix + s.id) }}"></div>
